import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';

interface SeatOverrunMessageProps {
  /** Overrides the locked-out copy — the resolver's dead end names another way out. */
  description?: string;
}

/**
 * What a locked-out user sees. Also what a resolver sees when the over-full
 * pools hold nobody but the resolver — an empty table would promise an action
 * that is not there.
 */
export function SeatOverrunMessage({ description }: SeatOverrunMessageProps = {}) {
  const { t } = useTranslation();

  return (
    // `self-center` rather than the parent's `items-center`: the resolver's
    // table has to start at the top of the same shell.
    <div className="max-w-md self-center text-center">
      <Lock className="mx-auto h-12 w-12 text-primary" />
      <h1 className="mt-6 text-2xl font-semibold text-foreground">
        {t('organization.seatOverrun.title')}
      </h1>
      <p className="mt-3 text-sm text-muted-foreground">
        {description ?? t('organization.seatOverrun.description')}
      </p>
    </div>
  );
}
